import React from 'react';
import lodash from 'lodash';
import { v4 as uuid, } from 'uuid';
import { money, } from '@payit/payit-formatter';
import AsyncActionButton from '../../button/AsyncActionButton';
import TenantService from '../../../service/TenantService';
import FeeService from '../../../service/FeeService';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';

class ServiceFeeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      isLoading: false,
    };
    TenantService.getAllServiceOfferings().then(({ data, }) => {
      let defaultServiceOfferingId;

      if (data.serviceOfferings && data.serviceOfferings.length > 0) {
        defaultServiceOfferingId = data.serviceOfferings[0]._id;
      }
      const combo = (
        <div>
          <select className="form-select mt-2 me-2" onBlur={event => this.onBlur(event)}>
            {data.serviceOfferings.map(serviceOffering => (
              <option key={uuid()} value={serviceOffering._id}>
                {lodash.startCase(serviceOffering.serviceOfferingName)}
              </option>
            ))}
          </select>
        </div>
      );
      this.setState({
        comboBox: combo,
        serviceOfferingId: defaultServiceOfferingId,
        isReady: true,
      });
    });
  }

  onBlur(event) {
    this.setState({
      serviceOfferingId: event.currentTarget.value,
    });
  }

  onSearch() {
    const { serviceOfferingId, } = this.state;
    const criteria = {
      serviceOfferingId,
    };
    this.reset();
    this.setState({
      isLoading: true,
    });
    FeeService.getFees(criteria)
      .then(({ data, }) => {
        const formatted = data.fees.map(fee => this.format(fee));
        const model = Grid.toModelFromList(formatted, {
          headerFormatter: value => lodash.startCase(value.header),
        });
        this.setState({
          headers: model.headers,
          rows: model.format(formatted),
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  format(fee) {
    return {
      description: fee.description,
      feePercentage: `${fee.feePercentage}%`,
      feeSite: fee.feeSite,
      feeType: fee.feeType,
      id: fee.id,
      minimumFee: money.printMoney(fee.minimumFeePennies || 0),
      staticFee: money.printMoney(fee.staticFee || 0),
      tenantID: fee.tenantID,
      timeFeeCreated: new Date(fee.timeFeeCreated).toUTCString(),
    };
  }

  reset() {
    this.setState({
      headers: [],
      rows: [],
    });
  }

  render() {
    const {
      headers, rows, comboBox, isReady, isLoading,
    } = this.state;
    if (!isReady) {
      return null;
    }
    return (
      <div className="container">
        <div className="container row">
          {comboBox}
          <div className="mt-2 ms-2">
            <AsyncActionButton
              contents="Search"
              isLoading={isLoading}
              variant="success"
              onClick={() => this.onSearch()}
            />
          </div>
        </div>
        <div style={{ marginTop: '50px', maxHeight: '400px', }}>
          <FieldSet title="Service Fees">
            <Grid headers={headers} rows={rows} />
          </FieldSet>
        </div>
      </div>
    );
  }
}

export default ServiceFeeView;
